function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14.5,
  fill: "white",
  stroke: "#BCBCBC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.1794 14.9998L21.4228 9.75643C21.7486 9.43094 21.7486 8.90282 21.4228 8.57733C21.0971 8.25157 20.5695 8.25157 20.2437 8.57733L15.0003 13.8207L9.75667 8.57733C9.43091 8.25157 8.90334 8.25157 8.57758 8.57733C8.25181 8.90282 8.25181 9.43094 8.57758 9.75643L13.8212 14.9998L8.57758 20.2432C8.25181 20.5687 8.25181 21.0968 8.57758 21.4223C8.74046 21.5849 8.95393 21.6663 9.16712 21.6663C9.38032 21.6663 9.59379 21.5849 9.75667 21.422L15.0003 16.1786L20.2437 21.422C20.4066 21.5849 20.6201 21.6663 20.8333 21.6663C21.0465 21.6663 21.2599 21.5849 21.4228 21.422C21.7486 21.0965 21.7486 20.5684 21.4228 20.2429L16.1794 14.9998Z",
  fill: "#7A8189"
});

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.eb65e933.svg";
export { ForwardRef as ReactComponent };